import { Inject, Options, Vue } from "vue-property-decorator";
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import { ExternalExaminer } from "@/shared/modules/typescript-trustapi-client/models";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-admin-app/appInsights";
import store from "@/trust-admin-app/store";
import { EventEmitter } from "events";
import { RouteN } from "@/trust-admin-app/constants/router-name";
import AddEeModal from "../trust-data-external-examiner/add-ee-modal/index.vue";

@Options({
  components: {
    LoadingSpinner,
    LoadingIndicator,
    AddEeModal,
  },
  mixins: [FormatDateTimeMixin]
})
export default class ExternalExaminerMain extends Vue {
  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private ai = new AppInsights;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private validatingEntrance = false;
  private hidePracticeInfo = false;
  private hideLeftPanel = false;
  private selectedEE: ExternalExaminer = {};

  private showAddEEModal = false; // use AddEeModal for editing EE

  created(): void {
    this.validateEntrance();
  }

  private async validateEntrance(): Promise<void> {
    this.validatingEntrance = true;
    const ExternalExaminerId: number = parseInt(this.$route.query.eeId as string, 10);

    try {
      if (!ExternalExaminerId) {
        throw new Error('No External Examiner selected');
      } else if (this.selectedEE.id === ExternalExaminerId) {
        this.validatingEntrance = false;
      } else if (this.selectedEE.id !== ExternalExaminerId) {

        const resp: any = await this.apiService.ExternalExaminerApi?.apiV2ExternalExaminerAdminGetExternalExaminerByIdExternalExaminerIdGet(ExternalExaminerId);
        const selectedEE: ExternalExaminer = resp.data.data;
        this.selectedEE = selectedEE;
        if (selectedEE) {
          store.dispatch('setSelectedEE', selectedEE as ExternalExaminer);
          this.validatingEntrance = false;
        } else {
          throw new Error('Invalid External Examiner');
        }
      }
    } catch (err: any) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Invalid External Examiner');
      this.ai.trackException('Error loading page: ' + 'Invalid External Examiner');
      this.$router.push({ name: RouteN.TA.Home.n });
    }
  }

  private async loadEE(): Promise<void> {
    const ExternalExaminerId: number = parseInt(this.$route.query.eeId as string, 10);
    const resp: any = await this.apiService.ExternalExaminerApi?.apiV2ExternalExaminerAdminGetExternalExaminerByIdExternalExaminerIdGet(ExternalExaminerId);
    const selectedEE: ExternalExaminer = resp.data.data;
    this.selectedEE = selectedEE;
    if (selectedEE) {
      store.dispatch('setSelectedEE', selectedEE as ExternalExaminer);
      this.validatingEntrance = false;
    } else {
      throw new Error('Invalid External Examiner');
    }
  }

  private showHideOptions(hideLeftPanel: boolean) {
    this.hideLeftPanel = !hideLeftPanel;
    if (this.hideLeftPanel) {
      this.hidePracticeInfo = true;
    } else {
      setTimeout(() => {
        this.hidePracticeInfo = false;
      }, 500);
    }
    this.eventCtrl.emit('side-panel-hidden', this.hideLeftPanel);
  }

  private async downloadFile(file: any): Promise<void> {
    try {
      const resp: any = await this.apiService.FileAtcsApi?.apiV2FileAtcsAdminDownloadStreamFileIdGet(
        file.id,
        { responseType: 'blob' }
      );
      const blob = new Blob([resp.data], { type: resp.headers['content-type'] });
      const documentURL = window.URL.createObjectURL(blob);
      const downloadLink = document.createElement('a');
      const fileName = file.fileName;
      downloadLink.href = documentURL;
      downloadLink.download = fileName;
      downloadLink.click();
    } catch (err) {
      console.log(err);
    }
  }

  private editEE(): void {
    this.showAddEEModal = true;
  }

}

